module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Section 1:")]), _vm._v(" Virgin Cross Country")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec01"
    }
  }, [_vm._v("1.1: Class 43-High Speed Trainsets (HST)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec02"
    }
  }, [_vm._v("1.2: Class 47")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec03"
    }
  }, [_vm._v("1.3: Class 86")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec04"
    }
  }, [_vm._v("1.4: Class 158-Express Sprinter")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec05"
    }
  }, [_vm._v("1.5: Classes 220/221")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec06"
    }
  }, [_vm._v("1.5.1: Class 220-‘Voyager’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Section1#sec07"
    }
  }, [_vm._v("1.5.2: Class 221-‘Super Voyager’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Section 2: Virgin Trains West Coast")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1: Class 43-High Speed Trainsets (HST)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2: Class 47")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3: Class 57/3-Thunderbird")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4: Class 82/1-Driving Van Trailer (DVT)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5: Class 86")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.6: Class 87")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.7: Class 90")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.8: Class 221 ‘Super Voyager’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section2#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.9: Class 390 ‘Pendolino’")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Section 3: Virgin Trains East Coast")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1: Class 43-High Speed Trainsets (HST)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2: Class 67")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3: Class 82/2-Driving Van Trailer (DVT)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4: Class 90")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5: Class 91/1")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section3#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6: Class 800/1-Intercity Express Train")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Section4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("Section 4:")]), _vm._v(" Virgin Trains – The End")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End – The Final Trains")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0